




















































import { GrupoDeCliente } from '@/models'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { GrupoDeClienteUseCase } from '@/usecases/cliente/GrupoDeClienteUseCase'
import { Component, Ref, Vue } from 'vue-property-decorator'
import SeletorDeGruposEconomicos from '../loja/SeletorDeGruposEconomicos.vue'

@Component({
	components: {
		SeletorDeGruposEconomicos,
	},
})
export default class DialogoDeEdicaoDoGrupoDoCliente extends Vue {
	@Ref() form!: HTMLFormElement
	grupoDeClienteUseCase = new GrupoDeClienteUseCase()

	grupoDeCliente: GrupoDeCliente = criarGrupoDeCliente()
	mostra = false
	salvando = false
	obrigatorio = obrigatorio

	get podeAlterarGrupoEconomico() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('alterar', 'grupo-do-cliente'))
	}

	get podeDeletarGrupoEconomico() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('deletar', 'grupo-do-cliente'))
	}

	get podeCriarGrupoEconomico() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('criar', 'grupo-do-cliente'))
	}

	get temAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	mostrar(grupo: GrupoDeCliente | null){
		if (grupo){ this.grupoDeCliente = grupo }
		this.mostra = true
	}
	
	async salvar(){
		if (!this.grupoDeCliente) return
		if (!this.form.validate()) return
		try {
			this.salvando = true
			const salvarGrupos = !this.grupoDeCliente.id
				? await this.grupoDeClienteUseCase.criarGrupoDeCliente(this.grupoDeCliente)
				: await this.grupoDeClienteUseCase.atualizarGrupoDeCliente(this.grupoDeCliente)

			this.$emit('confirmado', salvarGrupos)
			AlertModule.setSuccess('Grupo de Cliente salvo com sucesso')
			this.mostra = false
		} catch(error: any) {
			AlertModule.setError(error.response.data[0])
		} finally {
			this.salvando = false
		}
	}


}

export function criarGrupoDeCliente(): GrupoDeCliente {
	return {
		id: '',
		nome: '',
		grupoEconomico: null,
	}
}

